import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import profile from "../../assets/images/profile.jpg";
import Pagination from "./../../components/Pagination";
import SortList from "../../../src/components/sortlist/SortList";
import { Link } from "react-router-dom";
import ViewCustomer from "./ViewCustomer";
import { toast } from "react-toastify";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  customersList,
  cancelRecurring,
  updateCustomers,
} from "../../redux/action/customers";
import {
  CustomerDelete,
  multiCustomerDelete,
} from "../../redux/action/customers";
import { ToastContainer } from "react-toastify";
import dateFormat from "dateformat";
import { APIURL, SOCETCONNURL } from "../../redux/action/config";
import search from "../../utils/search";
import { io } from "socket.io-client";
import loader from "../../components/loader/loader";
import { filterActiveMemberships } from "../../utils/filter-active-membership";
import DownloadDropdown from "../../components/DownloadDropdown";

const CustomerList = ({
  pageLoading,
  customerListData,
  not_found,
  totalDocs,
  totalPages,
}) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [statusFilter, setStatusFilter] = useState("");

  const onChangePage = (pageNumber) => {
    setPage(pageNumber);
  };
  const [users, setUsers] = useState([]);

  const [id, setId] = useState();
  const [viewDetails, setViewDetails] = useState();

  const dispatch = useDispatch();

  const handleGetId = (e, id) => {
    e?.preventDefault();
    if (!id) return;
    if (id !== undefined) {
      setViewDetails("");
      const token = localStorage.getItem("token");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${APIURL}/api/v1/users/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result, "result");
          setViewDetails(result?.data?.user);
        })
        .catch((error) => console.log("error", error));
    }
  };

  useEffect(() => {
    dispatch(
      customersList({
        page,
        limit: 10,
        search: searchQuery,
        from: filterDate.startDate,
        to: filterDate.endDate,
        status: statusFilter,
      })
    );
  }, [dispatch, page, filterDate, statusFilter]);
  useEffect(() => {
    const socket = io(SOCETCONNURL);
    socket.on("user-list", (items) => {
      setUsers(items?.filter((item) => item.position == "user_customer"));
    });
  }, []);

  const customerDel = async (id) => {
    const res = await dispatch(CustomerDelete(id));
    if (res?.res?.status == "success") {
      // Optimistic update or just wait for re-fetch
    }
    setTimeout(() => {
      dispatch(
        customersList({
          page,
          limit: 10,
          search: searchQuery,
          from: filterDate.startDate,
          to: filterDate.endDate,
          status: statusFilter,
        })
      );
    }, 1000);
  };

  const [recheckingId, setRecheckingId] = useState(null);

  const recheckStatus = async (id) => {
    setRecheckingId(id);
    try {
      const token = localStorage.getItem("token");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const response = await fetch(
        `${APIURL}/api/v1/payments/recheck-status/${id}`,
        { method: "POST", headers: myHeaders, redirect: "follow" }
      );
      const result = await response.json();

      if (result?.result?.found === false) {
        toast.error("No Stripe payment or subscription found for this customer.");
      } else if (result?.result?.status === "succeeded") {
        toast.success("Stripe confirms payment succeeded - membership updated to Active.");
      } else if (result?.result?.status === "canceled") {
        toast.info("Stripe shows this subscription as canceled - membership marked Expired.");
      } else {
        toast.error("Stripe shows no successful payment - membership marked as Payment Failed.");
      }

      dispatch(
        customersList({
          page,
          limit: 10,
          search: searchQuery,
          from: filterDate.startDate,
          to: filterDate.endDate,
          status: statusFilter,
        })
      );
    } catch (error) {
      toast.error("Could not reach Stripe to recheck this customer's status.");
    } finally {
      setRecheckingId(null);
    }
  };

  const getMemberShipBadge = (status) => {    
    switch (status.toLowerCase()) {
      case "active":
        return "success";
      case "inactive":
        return "warning";
      case "expired":
        return "secondary";
      default:
        return "danger"; // Default badge for unknown status
    }
  };

  // const data = productDataList
  //   ? productDataList?.map((item) => {
  //       return {
  //         id: item?._id,
  //         name:
  //           item?.firstName && item?.lastName
  //             ? `${item?.firstName ? item?.firstName : ""} ${
  //                 item?.lastName ? item?.lastName : ""
  //               }`
  //             : "N/A",
  //         phone: item?.phone ? item?.phone : "N/A",
  //         address: item?.address ? item?.address : "N/A",
  //         image: item?.image ? item?.image : "N/A",
  //         email: item?.email ? item?.email : "N/A",
  //         vehicle: item?.vehicle ? item?.vehicle : "N/A",
  //         memberhip: item?.purched_memberships
  //           ? item?.purched_memberships
  //           : "N/A",
  //         status: item?.status ? item?.status : "N/A",
  //         created: item?.createdAt ? item?.createdAt : "N/A",
  //         updated: item?.updatedAt ? item?.updatedAt : "N/A",
  //       };
  //     })
  //   : "";

  const [loading, setLoading] = React.useState(true);
  const [allUsers, setAllUsers] = React.useState();
  setTimeout(() => {
    setLoading(false);
  }, 2000);

  // *********** All Select Delete ***********
  const [btnStatus, setBtnStatus] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // const [list, setList] = useState([]);
  // useEffect(() => {
  //   setList(productDataList);
  // }, [productDataList]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(customerListData.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  const handleAllDelete = () => {
    multiCustomerDelete(isCheck);
    setTimeout(() => {
      dispatch(
        customersList({
          page,
          limit: 10,
          search: searchQuery,
          from: filterDate.startDate,
          to: filterDate.endDate,
          status: statusFilter,
        })
      );
      setIsCheckAll(false);
      setIsCheck([]);
    }, 1000);
  };

  //  cancle recrunning

  const cancleRecurringHandle = (id, userId) => {
    const payload = {
      subId: id,
    };
    const value = {
      subscrptStatus: true,
    };
    cancelRecurring(payload, (res) => {
      if (res === "success") {
        dispatch(updateCustomers(value, userId));
      }
    });
  };

  // pdf code start
  // const downloadPDF = () => {
  //   const capture = document.querySelector(".table");
  //   html2canvas(capture).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     console.log("Image Data:", imgData); // Debugging: Log the image data
  //     const doc = new jsPDF("p", "mm", "a4");
  //     const imgWidth = 200; // Adjust this based on your needs
  //     const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
  //     doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  //     doc.save("roadside-response.pdf");
  //   });
  // };
  // pdf code end
  // console.log(productDataList, "productDataList");

  // date filter start
  const handleOnchangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterDate({
      ...filterDate,
      [name]: value,
    });
    setPage(1); // Reset to page 1 on filter change
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setPage(1);
  };

  const handleResetFilter = () => {
    setFilterDate({ startDate: "", endDate: "" });
    setStatusFilter("");
    setPage(1);
  };

  const applySearch = () => {
    setPage(1);
    dispatch(
      customersList({
        page: 1,
        limit: 10,
        search: searchQuery,
        from: filterDate.startDate,
        to: filterDate.endDate,
        status: statusFilter,
      })
    );
  };

  // console.log(productDataList, "listDatalistData");
  // date filter End

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Customers List" page="customers">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="row pt-4 pb-4">
                    <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                      <div
                        className="dataTables_length"
                        id="kt_datatable_example_5_length"
                      >
                        <div className="filter-table-data ml-5 d-flex align-items-center">
                          {isCheck && isCheck?.length > 0 ? (
                            <button
                              onClick={() => {
                                handleAllDelete();
                              }}
                              className="delete-selected me-4"
                            >
                              Delete Selected
                            </button>
                          ) : (
                            ""
                          )}
                          <div className="">
                            <input
                              className="form-control"
                              name="startDate"
                              type="date"
                              value={filterDate.startDate}
                              onChange={(e) => {
                                handleOnchangeFilter(e);
                              }}
                            />
                          </div>
                          <span className="mx-4 fw-bolder">To</span>
                          <div>
                            <input
                              className="form-control"
                              name="endDate"
                              type="date"
                              min={filterDate.startDate || ""}
                              value={filterDate.endDate}
                              onChange={(e) => {
                                handleOnchangeFilter(e);
                              }}
                            />
                          </div>
                          <div className="ms-2">
                            <select
                              className="form-control form-select"
                              name="status"
                              value={statusFilter}
                              onChange={handleStatusFilterChange}
                            >
                              <option value="">All Statuses</option>
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                              <option value="Expired">Expired</option>
                              <option value="Payment Failed">Payment Failed</option>
                            </select>
                          </div>
                          {(filterDate.startDate || filterDate.endDate || statusFilter) ? (
                            <button
                              type="button"
                              className="btn btn-light-danger ms-2"
                              onClick={handleResetFilter}
                            >
                              Reset
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 d-flex align-items-center justify-content-end">
                      <div
                        id="kt_datatable_example_5_filter"
                        className="dataTables_filter"
                      >
                        <label className="w-100">
                          <span className="me-2">Search:</span>

                          <div className="position-relative w-100">
                            <input
                              type="search"
                              value={searchQuery}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                if (e.target.value === "") {
                                  dispatch(
                                    customersList({
                                      page: 1,
                                      limit: 10,
                                      search: "",
                                      from: filterDate.startDate,
                                      to: filterDate.endDate,
                                      status: statusFilter,
                                    })
                                  );
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  applySearch();
                                }
                              }}
                              className="form-control form-control-sm form-control-solid pe-10"
                              placeholder="Search..."
                              aria-controls="kt_datatable_example_5"
                            />

                            {/* Button INSIDE input */}
                            {searchQuery !== "" && (
                              <button
                                type="button"
                                onClick={applySearch}
                                className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-1"
                                aria-label="Search"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  fill="currentColor"
                                  className="bi bi-search"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                              </button>
                            )}
                          </div>
                        </label>
                      </div>
                      <DownloadDropdown
                        moduleName="users"
                        fileName="users_export"
                        filters={{
                          search: searchQuery,
                          from: filterDate.startDate,
                          to: filterDate.endDate,
                          status: statusFilter,
                        }}
                      />
                    </div>
                  </div>
                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                    >
                      <thead>
                        <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                          {/* <th style={{ width: "115.188px" }}>
                            Profile Picture
                          </th> */}
                          <th style={{ padding: "16px 0px 16px 24px" }}>
                            <input
                              type="checkbox"
                              name="selectAll"
                              id="selectAll"
                              onClick={() => {
                                handleSelectAll();
                                setBtnStatus(true);
                              }}
                              checked={isCheckAll}
                              className="form-check-input custum-check"
                            />
                          </th>
                          <th style={{ width: "79.5625px" }}>First Name</th>
                          <th style={{ width: "118.641px" }}>Phone Number</th>
                          <th style={{ width: "145.328px" }}>Email Address</th>
                          {/* <th style={{ width: "145.156px" }}>Address</th> */}
                          {/* <th style={{ width: "100.969px" }}>Joining Date</th> */}
                          <th style={{ width: "63.156px" }}>Status</th>
                          <th style={{ width: "145.328px" }}>Membership</th>
                          <th style={{ width: "145.328px" }}>
                            Subscription Type
                          </th>
                          <th style={{ width: "195px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerListData.length > 0 ? (
                          customerListData?.map((item, index) => {
                            const {
                              hasMembership,
                              memberships,
                              subscriptionType,
                              subscriptionId,
                              status: membershipStatus,
                            } = filterActiveMemberships(
                              item?.purched_memberships,
                              item?.subscriptionType,
                              item?.subscriptionId
                            );
                            return (
                              <tr key={index}>
                                {/* <td>
                                  <img
                                    src={item.image ? item.image : profile}
                                    alt="profile"
                                  />
                                </td> */}
                                <td
                                  style={{ width: "20px" }}
                                  className="check-list"
                                >
                                  <input
                                    type="checkbox"
                                    name={item?.firstName}
                                    id={item?.id}
                                    onClick={(e) => handleClick(e)}
                                    checked={isCheck.includes(item?.id)}
                                    className="form-check-input custum-check"
                                  />
                                </td>
                                <td>
                                  {item.firstName ? item.firstName : "N/A"}
                                </td>
                                <td>{item.phone ? item.phone : "N/A"}</td>
                                <td>{item.email ? item.email : "N/A"}</td>
                                <td>
                                  <span
                                    className={`btn ${getMemberShipBadge(membershipStatus)} text-capitalize`}
                                  >
                                    {membershipStatus}
                                  </span>
                                </td>
                                <td>
                                  {hasMembership
                                    ? memberships?.[0]?.name
                                    : "N/A"}
                                </td>
                                <td className="text-capitalize">
                                  {hasMembership ? subscriptionType : "N/A"}
                                </td>
                                {/* <td>
                                  {item?.address[0]?.address
                                    ? item?.address[0]?.address
                                    : item.city
                                    ? item.city
                                    : ""}
                                </td> */}
                                {/* <td>
                                  {dateFormat(item.joi_date, "d mmmm , yyyy")}
                                </td> */}
                                {/* <td>
                                  <span
                                    className={`btn ${getBadge(
                                      item.status
                                    )} text-capitalize`}
                                  >
                                    {item.status ? item.status : "N/A"}
                                  </span>
                                </td> */}
                                <td>
                                  <div className="d-flex align-items-center gap-1">
                                    <a
                                      type="button"
                                      onClick={(e) => handleGetId(e, item?._id)}
                                      className="btn btn-primary m-0"
                                      data-bs-toggle="modal"
                                      data-bs-target="#customerDetailModal"
                                      title="View customer details"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-eye-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                      </svg>
                                    </a>
                                    <ViewCustomer
                                      modalId={"customerDetailModal"}
                                      viewDetails={viewDetails ? viewDetails : ""}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => recheckStatus(item?._id)}
                                      disabled={recheckingId === item?._id}
                                      className="btn btn-warning action-hover"
                                      title="Recheck payment status with Stripe"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-arrow-clockwise"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                        />
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                      </svg>
                                    </button>
                                    {/* <Link
                                    to="#"
                                    onClick={() => setId(item.id)}
                                    className="btn btn-bg-primary action-hover"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-eye-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                  </Link> */}
                                    <Link
                                      to={`/customer-record/${item._id}`}
                                      className="btn btn-primary action-hover m-0"
                                      title="Print customer payment record"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-printer"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"
                                        />
                                      </svg>
                                    </Link>
                                    <Link
                                      to={`/edit-customers/${item.id}`}
                                      onClick={() => setId(item.id)}
                                      className="btn btn-info action-hover m-0"
                                      title="Edit customer"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil-square"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                        />
                                      </svg>
                                    </Link>
                                    <Link
                                      to="/manage-customers"
                                      onClick={() => customerDel(item.id)}
                                      className="btn btn-bg-dark action-hover m-0"
                                      title="Delete customer"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                      </svg>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <div className="spinner-outer p-5">
                            {pageLoading == true ? (
                              <div className="spinner-outer p-5">
                                {loader()}
                              </div>
                            ) : (
                              <p>Data not found</p>
                            )}
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Pagination
                  pageSize={10}
                  totalItems={totalDocs || 0}
                  serverSide={true}
                  items={customerListData}
                  onChangePage={onChangePage}
                  initialPage={page}
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  pageLoading: state?.customers?.loading,
  customerListData: state?.customers?.list,
  not_found: state?.customers?.not_found,
  totalDocs: state?.customers?.totalDocs,
  totalPages: state?.customers?.totalPages,
});

export default connect(mapStateToProps, { customersList })(CustomerList);
